export default __webpack_public_path__ + "static/media/Kundi-Bhandara.eb539271.jpg";